import * as tslib_1 from "tslib";
import api from '../api';
import ProjectStatistics from '../models/ProjectStatistics';
var endPoints = {
    projects: 'api/project',
    configuration: 'api/project/settings',
    statistics: 'api/project/statistic'
};
var ProjectApi = /** @class */ (function () {
    function ProjectApi() {
    }
    ProjectApi.getProjectConfiguration = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.configuration)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ProjectApi.getProjects = function (sprintIndex) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.projects, { sprintIndex: sprintIndex })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    ProjectApi.getProjectStatistics = function (projectId, sprintIndex) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.statistics, {
                            projectId: projectId,
                            sprintIndex: sprintIndex
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new ProjectStatistics(data)];
                }
            });
        });
    };
    return ProjectApi;
}());
export default ProjectApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/ProjectApi.ts
// module id = 372
// module chunks = 0